export default __webpack_public_path__ + "static/small-business-accomplishment-3e-4200fbbfd884765c8014df5cd332b4f2.webp";